<template>
    <div class="tm-rule">
        <router-view></router-view>

        <div class="tm-page">
            <!-- KPI -->
            <div class="tm-kpis">
                <div class="tm-kpi" :style="{ '--c': '#4fc3ff', '--c-a': 'rgba(79,195,255,.45)', '--c-b': 'rgba(79,195,255,.22)' }">
                    <div class="tm-ring">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4fc3ff" stroke-width="2"><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H19v18H6.5A2.5 2.5 0 0 1 4 18.5z"/><path d="M8 7h7M8 11h7"/></svg>
                    </div>
                    <div class="info">
                        <div class="label">评课标准总数</div>
                        <div class="value">{{ dash.total }}<small>套</small></div>
                        <div class="trend">二级 {{ dash.lvl2 }} · 三级 {{ dash.lvl3 }}</div>
                    </div>
                </div>

                <div class="tm-kpi" :style="{ '--c': '#35e0b0', '--c-a': 'rgba(53,224,176,.45)', '--c-b': 'rgba(53,224,176,.22)' }">
                    <div class="tm-ring">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#35e0b0" stroke-width="2"><path d="M3 21h18M6 21V8l6-5 6 5v13"/><path d="M10 21v-5h4v5"/></svg>
                    </div>
                    <div class="info">
                        <div class="label">覆盖院校</div>
                        <div class="value">{{ dash.deptCount }}<small>所</small></div>
                        <div class="trend">平均每校 {{ avgPerDept }} 套 · 最多 {{ topDeptCount }} 套</div>
                    </div>
                </div>

                <div class="tm-kpi" :style="{ '--c': '#a78bfa', '--c-a': 'rgba(167,139,250,.45)', '--c-b': 'rgba(167,139,250,.22)' }">
                    <div class="tm-ring">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#a78bfa" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>
                    </div>
                    <div class="info">
                        <div class="label">关联指标项</div>
                        <div class="value">{{ dash.itemTotal }}<small>项</small></div>
                        <div class="trend">分布于 {{ dash.groupTotal }} 个指标组</div>
                    </div>
                </div>

                <div class="tm-kpi" :style="{ '--c': '#ffd24a', '--c-a': 'rgba(255,210,74,.45)', '--c-b': 'rgba(255,210,74,.22)' }">
                    <div class="tm-ring">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ffd24a" stroke-width="2"><path d="M4 19V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14l-8-4-8 4z"/><path d="M9 8h6"/></svg>
                    </div>
                    <div class="info">
                        <div class="label">标准使用率</div>
                        <div class="value">{{ dash.usageRate }}<small>%</small></div>
                        <div class="trend">{{ dash.usedTemplates }} / {{ dash.total }} 套被引用 · {{ dash.usedLessons }} 节课</div>
                    </div>
                </div>
            </div>

            <!-- 中段三栏 -->
            <div class="tm-grid">
                <div class="tm-card">
                    <div class="tm-title">标准使用 TOP10<span class="more">按引用课数排序</span></div>
                    <div class="tm-rank" v-if="dash.topUsed.length">
                        <div class="tm-rank-row" v-for="(item, i) in dash.topUsed" :key="'u' + i">
                            <div class="tm-no" :class="'n' + (i + 1)">{{ i + 1 }}</div>
                            <div class="tm-rname" :title="item.name">{{ item.name }}</div>
                            <div class="tm-track"><div class="tm-fill" :class="{ gold: i === 0 }" :style="{ width: barW(item.count, topUsedMax) }"></div></div>
                            <div class="tm-rval"><b>{{ item.count }}</b> 节</div>
                        </div>
                    </div>
                    <div class="tm-empty" v-else>暂无被引用的标准</div>
                </div>

                <div class="tm-card">
                    <div class="tm-title">近 12 月标准创建趋势<span class="more">单位：套</span></div>
                    <div ref="trendChart" class="tm-chart"></div>
                </div>

                <div class="tm-card">
                    <div class="tm-title">指标层级构成</div>
                    <div ref="levelChart" class="tm-chart tm-chart-sm"></div>
                    <div class="tm-legend">
                        <div class="item" v-for="(l, i) in levelLegend" :key="'l' + i">
                            <i class="dot" :style="{ background: l.color, color: l.color }"></i>{{ l.label }}
                            <span class="num">{{ l.count }}</span>
                            <span class="pct">{{ ratio(l.count, levelTotal) }}%</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 下段两栏 -->
            <div class="tm-grid2">
                <div class="tm-card">
                    <div class="tm-title">院校标准数量 TOP10<span class="more">共 {{ dash.deptCount }} 所院校</span></div>
                    <div class="tm-rank" v-if="dash.topDepts.length">
                        <div class="tm-rank-row" v-for="(item, i) in dash.topDepts" :key="'d' + i">
                            <div class="tm-no" :class="'n' + (i + 1)">{{ i + 1 }}</div>
                            <div class="tm-rname" :title="item.name">{{ item.name }}</div>
                            <div class="tm-track"><div class="tm-fill purple" :style="{ width: barW(item.count, topDeptMax) }"></div></div>
                            <div class="tm-rval"><b>{{ item.count }}</b> 套</div>
                        </div>
                    </div>
                    <div class="tm-empty" v-else>暂无数据</div>
                </div>

                <div class="tm-card">
                    <div class="tm-title">标准规模分布<span class="more">按指标组数分档</span></div>
                    <div class="tm-dist">
                        <div class="item" v-for="(s, i) in dash.scaleDist" :key="'s' + i">
                            <span class="lb">{{ s.name }}</span>
                            <div class="track"><div class="fill" :style="{ width: barW(s.count, scaleMax) }"></div></div>
                            <span class="num">{{ s.count }}</span>
                        </div>
                    </div>
                    <div class="level-foot">
                        <span>平均每套标准</span>
                        <span><b>{{ avgGroups }}</b> 组 · <b>{{ avgItems }}</b> 项指标</span>
                    </div>
                </div>
            </div>

            <!-- 列表 -->
            <div class="tm-card">
                <div class="tm-title">标准明细<span class="more">共 {{ filteredRows.length }} 条</span></div>

                <div class="tm-toolbar">
                    <div class="search-box">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4f77ab" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>
                        <input type="text" v-model="query.name" placeholder="请输入评课标准名称" @keyup.enter="doSearch" />
                    </div>
                    <select v-model="query.level" @change="doSearch">
                        <option value="">指标模版</option>
                        <option value="2">二级指标模版</option>
                        <option value="3">三级指标模版</option>
                        <option value="5">二级指标模版(新)</option>
                    </select>
                    <select v-model="query.dept" @change="doSearch">
                        <option value="">全部院校</option>
                        <option v-for="d in deptOptions" :key="d" :value="d">{{ d }}</option>
                    </select>
                    <select v-model="query.used" @change="doSearch">
                        <option value="">全部使用状态</option>
                        <option value="1">已被引用</option>
                        <option value="0">尚未使用</option>
                    </select>
                    <button class="btn btn-primary" @click="doSearch">查询</button>
                    <button class="btn" @click="resetSearch">重置</button>

                    <el-popover placement="bottom-end" trigger="click" width="170" popper-class="tm-pop">
                        <div slot="reference" class="btn btn-add">＋ 新建标准</div>
                        <div class="tm-options">
                            <div class="tm-option" @click="handleAddTemplate(2)">二级指标模板</div>
                            <div class="tm-option" @click="handleAddTemplate(3)">三级指标模板</div>
                            <div class="tm-option" @click="handleAddTemplate(5)">二级指标模版(新)</div>
                        </div>
                    </el-popover>
                </div>

                <table>
                    <colgroup>
                        <col style="width:70px"><col><col style="width:158px"><col style="width:150px">
                        <col style="width:86px"><col style="width:104px"><col style="width:118px"><col style="width:150px">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>ID</th><th>评课标准名称</th><th>关联院校</th><th>指标模版</th>
                            <th>指标组</th><th>被引用</th><th>创建时间</th><th>操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in pageRows" :key="row.id">
                            <td class="tm-id">{{ row.id }}</td>
                            <td class="t-name" :title="row.templateName">{{ row.templateName }}</td>
                            <td class="tm-dept" :title="row.deptName">{{ row.deptName }}</td>
                            <td>
                                <span class="tag" :class="levelTagClass(row.level)">{{ levelText(row.level) }}</span>
                            </td>
                            <td class="tm-num">{{ row.groupCount || 0 }}</td>
                            <td class="tm-num" :class="{ hot: row.usedCount > 0, none: !row.usedCount }">
                                {{ row.usedCount > 0 ? row.usedCount + ' 节' : '未使用' }}
                            </td>
                            <td class="tm-dept">{{ (row.createTime || '').slice(0, 10) }}</td>
                            <td class="op">
                                <router-link :to="{ path: Number(row.level) === 3 ? '/module/add_new' : (Number(row.level) === 5 ? '/module/add_new2' : '/module/add'), query: { id: row.id } }">编辑</router-link>
                                <span @click="handleClickClone(row)">克隆</span>
                                <el-popconfirm title="是否确定删除？" @confirm="handleDel(row)">
                                    <span slot="reference" class="del">删除</span>
                                </el-popconfirm>
                            </td>
                        </tr>
                        <tr v-if="!pageRows.length">
                            <td colspan="8" class="tm-empty">暂无符合条件的评课标准</td>
                        </tr>
                    </tbody>
                </table>

                <div class="table-foot">
                    <span>共 {{ filteredRows.length }} 条记录 · 第 {{ page }} / {{ pageCount }} 页</span>
                    <el-pagination background layout="prev, pager, next" small
                        :total="filteredRows.length" :page-size="pageSize" :current-page.sync="page">
                    </el-pagination>
                </div>
            </div>
        </div>

        <!-- 克隆弹窗（保留原功能） -->
        <el-dialog title="克隆" :visible.sync="clone.cloneConfigureShow" center :append-to-body="true" width="600px">
            <el-form ref="cloneform" :model="clone.form" label-width="80px">
                <el-form-item label="评课标准名称">
                    <el-input v-model="clone.form.templateName"></el-input>
                </el-form-item>
                <el-form-item label="院校" v-if="clone.manager">
                    <el-select style="width: 100%;" v-model="clone.deptId" filterable remote reserve-keyword
                        placeholder="请输入院校查询" :remote-method="remoteMethod" :loading="clone.cloneLoading">
                        <el-option v-for="item in clone.select" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">立即提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import { lists, del, get_module, create, clone as setClone, dashboard } from '@/request/api/module.js'
import { lists as college_lists } from '@/request/api/college.js'
import { get_user } from '@/request/api/user.js'

const SAMPLE_SIZE = 1000

export default {
    data() {
        return {
            allRows: [],
            dash: {
                total: 0, lvl2: 0, lvl3: 0, lvl4: 0, deptCount: 0,
                groupTotal: 0, itemTotal: 0, usedTemplates: 0, usedLessons: 0, usageRate: 0,
                topUsed: [], topDepts: [], trend: [], scaleDist: [],
            },
            query: { name: '', level: '', dept: '', used: '' },
            applied: { name: '', level: '', dept: '', used: '' },
            page: 1,
            pageSize: 10,
            loading: false,
            isEdit: false,

            clone: {
                cloneConfigureShow: false,
                cloneLoading: false,
                select: [],
                deptId: '',//院校id
                manager: false,
                form: {
                    templateName: '',
                    templateId: '',
                }
            },
        }
    },
    computed: {
        scopeText() {
            return this.clone.manager ? '全平台' : '本院校'
        },
        // 院校下拉直接从数据中去重，避免出现选不到的院校
        deptOptions() {
            const set = []
            this.allRows.forEach(r => {
                if (r.deptName && set.indexOf(r.deptName) < 0) set.push(r.deptName)
            })
            return set
        },
        filteredRows() {
            const q = this.applied
            return this.allRows.filter(r => {
                if (q.name && (r.templateName || '').indexOf(q.name) < 0) return false
                if (q.level && Number(r.level) !== Number(q.level)) return false
                if (q.dept && r.deptName !== q.dept) return false
                if (q.used === '1' && !(r.usedCount > 0)) return false
                if (q.used === '0' && r.usedCount > 0) return false
                return true
            })
        },
        pageRows() {
            const s = (this.page - 1) * this.pageSize
            return this.filteredRows.slice(s, s + this.pageSize)
        },
        pageCount() {
            return Math.max(1, Math.ceil(this.filteredRows.length / this.pageSize))
        },
        levelTotal() {
            return this.dash.lvl2 + this.dash.lvl3
        },
        levelLegend() {
            return [
                { label: '二级指标', count: this.dash.lvl2, color: '#ffd24a' },
                { label: '三级指标', count: this.dash.lvl3, color: '#4fc3ff' },
            ]
        },
        avgGroups() {
            return this.dash.total ? (this.dash.groupTotal / this.dash.total).toFixed(1) : '0.0'
        },
        avgItems() {
            return this.dash.total ? (this.dash.itemTotal / this.dash.total).toFixed(1) : '0.0'
        },
        avgPerDept() {
            return this.dash.deptCount ? (this.dash.total / this.dash.deptCount).toFixed(1) : '0.0'
        },
        topDeptCount() {
            return this.dash.topDepts.length ? this.dash.topDepts[0].count : 0
        },
        topUsedMax() {
            return this.dash.topUsed.length ? this.dash.topUsed[0].count : 1
        },
        scaleMax() {
            return this.dash.scaleDist.length ? Math.max.apply(null, this.dash.scaleDist.map(s => s.count)) : 1
        },
    },
    watch: {
        $route(val, old) {
            //返回刷新
            if (val.name == 'module') {
                this.init()
            }
        }
    },
    created() {
        this.init()
        this.get_role()
        this.get_college_lists('')
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
        if (this.trendChart) { this.trendChart.dispose(); this.trendChart = null }
        if (this.levelChart) { this.levelChart.dispose(); this.levelChart = null }
    },
    methods: {
        init() {
            this.loading = true
            lists({ page: 1, size: SAMPLE_SIZE }).then(res => {
                this.allRows = (res.data && res.data.list) || []
                this.loading = false
                if (this.page > this.pageCount) this.page = 1
            }).catch(() => { this.loading = false })
            this.loadDashboard()
        },

        loadDashboard() {
            dashboard({}).then(res => {
                const d = (res && res.data) || {}
                this.dash = Object.assign({
                    total: 0, lvl2: 0, lvl3: 0, lvl4: 0, deptCount: 0,
                    groupTotal: 0, itemTotal: 0, usedTemplates: 0, usedLessons: 0, usageRate: 0,
                    topUsed: [], topDepts: [], trend: [], scaleDist: [],
                }, d)
                this.$nextTick(() => {
                    this.renderTrend()
                    this.renderLevel()
                })
            }).catch(() => {})
        },

        renderTrend() {
            const el = this.$refs.trendChart
            if (!el) return
            if (this.trendChart) this.trendChart.dispose()
            this.trendChart = echarts.init(el)
            const trend = this.dash.trend || []
            this.trendChart.setOption({
                grid: { left: 6, right: 12, top: 22, bottom: 4, containLabel: true },
                tooltip: {
                    trigger: 'axis',
                    confine: true,
                    backgroundColor: 'rgba(6,22,54,.94)',
                    borderColor: 'rgba(53,224,176,.5)',
                    textStyle: { color: '#cfe6ff', fontSize: 12 },
                    axisPointer: { type: 'line', lineStyle: { color: 'rgba(53,224,176,.5)' } },
                    formatter: p => p[0].name + '<br/>新建 ' + p[0].value + ' 套',
                },
                xAxis: {
                    type: 'category',
                    data: trend.map(t => t.name),
                    axisLine: { lineStyle: { color: 'rgba(63,156,255,.28)' } },
                    axisTick: { show: false },
                    axisLabel: { color: '#5f8fd0', fontSize: 10, interval: 0 },
                },
                yAxis: {
                    type: 'value',
                    minInterval: 1,
                    splitLine: { lineStyle: { color: 'rgba(63,156,255,.14)' } },
                    axisLabel: { color: '#5f8fd0', fontSize: 10 },
                },
                series: [{
                    type: 'line',
                    smooth: true,
                    symbolSize: 6,
                    data: trend.map(t => t.count),
                    lineStyle: { width: 2, color: '#35e0b0' },
                    itemStyle: { color: '#020a1c', borderColor: '#35e0b0', borderWidth: 2 },
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: 'rgba(53,224,176,.42)' },
                            { offset: 1, color: 'rgba(53,224,176,0)' },
                        ]),
                    },
                }],
            })
        },

        renderLevel() {
            const el = this.$refs.levelChart
            if (!el) return
            if (this.levelChart) this.levelChart.dispose()
            this.levelChart = echarts.init(el)
            const data = [
                { value: this.dash.lvl2, name: '二级指标', itemStyle: { color: '#ffd24a' } },
                { value: this.dash.lvl3, name: '三级指标', itemStyle: { color: '#4fc3ff' } },
            ].filter(d => d.value > 0)
            this.levelChart.setOption({
                tooltip: {
                    trigger: 'item',
                    confine: true,
                    backgroundColor: 'rgba(6,22,54,.94)',
                    borderColor: 'rgba(79,195,255,.5)',
                    textStyle: { color: '#cfe6ff', fontSize: 12 },
                    formatter: '{b}：{c} 套（{d}%）',
                },
                series: [{
                    type: 'pie',
                    radius: ['58%', '82%'],
                    center: ['50%', '50%'],
                    avoidLabelOverlap: true,
                    label: { show: false },
                    labelLine: { show: false },
                    itemStyle: { borderColor: '#061a3d', borderWidth: 2 },
                    data: data.length ? data : [{ value: 1, name: '暂无', itemStyle: { color: 'rgba(63,156,255,.25)' } }],
                }],
            })
        },

        onResize() {
            if (this.trendChart) this.trendChart.resize()
            if (this.levelChart) this.levelChart.resize()
        },

        barW(val, max) {
            const m = max || 1
            return Math.max(2, Math.round((val || 0) * 100 / m)) + '%'
        },

        ratio(part, all) {
            if (!all) return '0.0'
            return (part * 100 / all).toFixed(1)
        },

        levelText(level) {
            const l = Number(level)
            if (l === 5) return '二级指标模版(新)'
            if (l === 4) return '四级指标模版'
            if (l === 3) return '三级指标模版'
            return '二级指标模版'
        },

        levelTagClass(level) {
            const l = Number(level)
            if (l === 3) return 'tag-l3'
            if (l === 4) return 'tag-l4'
            return 'tag-l2'
        },

        doSearch() {
            this.applied = Object.assign({}, this.query)
            this.page = 1
        },

        resetSearch() {
            this.query = { name: '', level: '', dept: '', used: '' }
            this.doSearch()
        },

        //获取角色
        get_role() {
            get_user(this.$store.state.user.id).then(res => {
                res.data.roleList && res.data.roleList.forEach(item => {
                    if (item.slug == 'super_manager') {
                        this.clone.manager = true;
                        return;
                    }
                })
            })
        },

        //院校列表
        get_college_lists(query) {
            college_lists({ name: query, page: 1, size: 10000 }).then(res => {
                this.clone.select = res.data.list
            })
        },

        //select搜索院校
        remoteMethod(query) {
            this.get_college_lists(query)
        },

        //列表点击克隆按钮
        handleClickClone(data) {
            this.clone.cloneConfigureShow = true
            this.clone.form.templateId = data.id
            this.clone.form.templateName = data.templateName + '_克隆'
        },

        //提交克隆
        onSubmit() {
            var data = JSON.parse(JSON.stringify(this.clone.form))
            if (this.clone.manager) {
                data['deptId'] = this.clone.deptId
            }
            setClone(data).then(res => {
                if (res.code != 0) return this.$notify.error({ title: '错误', message: res.msg });
                this.init()
                this.$notify({ title: '成功', message: res.msg, type: 'success' });
                this.clone.cloneConfigureShow = false
            })
        },
        //删除
        handleDel(data) {
            del({ id: data.id }).then(res => {
                if (res.code != 0) return this.$notify.error({ title: '错误', message: res.msg });
                this.init()
                this.$notify({ title: '成功', message: res.msg, type: 'success' });
            })
        },

        // 处理模板添加
        handleAddTemplate(level) {
            if (level === 2) {
                this.$router.push({
                    path: '/module/add'
                });
            } else if (level === 5) {
                this.$router.push({
                    path: '/module/add_new2'
                });
            } else {
                this.$router.push({
                    path: '/module/add_new'
                });
            }
        }
    }
}
</script>


<style scoped lang="less">
.tm-rule {
    .tm-page {
        margin: 0 10px 20px;
        color: #cfe6ff;
        font-size: 13px;
    }

    /* 横幅 */
    /* KPI */
    .tm-kpis {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 14px;
        margin-bottom: 16px;
    }

    .tm-kpi {
        display: flex;
        align-items: center;
        gap: 14px;
        position: relative;
        overflow: hidden;
        background: linear-gradient(180deg, rgba(16, 55, 130, 0.35), rgba(8, 25, 60, 0.35));
        border: 1px solid var(--c-a);
        border-radius: 8px;
        padding: 14px 18px;

        &::after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 3px;
            background: linear-gradient(180deg, var(--c), #0b2350);
            box-shadow: 0 0 10px var(--c);
        }

        &::before {
            content: '';
            position: absolute;
            right: -30px;
            top: -30px;
            width: 90px;
            height: 90px;
            border-radius: 50%;
            background: radial-gradient(circle, var(--c-b), transparent 70%);
        }

        .tm-ring {
            flex: none;
            width: 52px;
            height: 52px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: radial-gradient(circle, var(--c-b), rgba(8, 25, 60, 0.9));
            border: 1px solid var(--c-a);
            box-shadow: 0 0 14px var(--c-a), inset 0 0 12px var(--c-b);
        }

        .info {
            .label {
                font-size: 12px;
                color: #7ea6d9;
                margin-bottom: 4px;
            }

            .value {
                font-size: 26px;
                font-weight: 500;
                font-family: 'DIN Alternate', 'Segoe UI', sans-serif;
                background-image: linear-gradient(180deg, #ffffff, var(--c));
                -webkit-background-clip: text;
                background-clip: text;
                color: transparent;

                small {
                    font-size: 12px;
                    margin-left: 3px;
                }
            }

            .trend {
                font-size: 11px;
                margin-top: 3px;
                color: var(--c);
                opacity: 0.92;
            }
        }
    }

    /* 卡片 */
    .tm-card {
        background: linear-gradient(180deg, rgba(13, 40, 95, 0.35), rgba(5, 18, 45, 0.55));
        border: 1px solid rgba(63, 156, 255, 0.28);
        border-radius: 8px;
        padding: 14px 16px;
        box-shadow: inset 0 0 24px rgba(20, 70, 170, 0.15);
    }

    .tm-grid {
        display: grid;
        grid-template-columns: 5fr 4fr 3fr;
        gap: 14px;
        margin-bottom: 16px;
    }

    .tm-chart {
        height: 200px;
    }

    .tm-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        font-weight: 500;
        color: #dceeff;
        letter-spacing: 1px;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid transparent;
        border-image: linear-gradient(90deg, rgba(63, 156, 255, 0.8), transparent) 1;

        &::before {
            content: '';
            width: 8px;
            height: 8px;
            background: #3f9cff;
            transform: rotate(45deg);
            box-shadow: 0 0 8px #3f9cff;
        }

        .more {
            margin-left: auto;
            font-size: 12px;
            color: #5f8fd0;
            cursor: pointer;
            font-weight: 400;

            &:hover { color: #4fc3ff; }
        }
    }

    /* 层级面板 */
    .tm-level {
        display: flex;
        flex-direction: column;
        gap: 18px;
        margin-top: 8px;
    }

    .level-row {
        font-size: 12px;
        color: #a9c6e8;

        .head {
            display: flex;
            align-items: baseline;
            gap: 8px;
            margin-bottom: 7px;

            .num {
                margin-left: auto;
                font-family: Consolas, monospace;
                font-size: 15px;
                color: #6fc4ff;
                text-shadow: 0 0 8px rgba(79, 195, 255, 0.6);
            }
        }
    }

    .level-bar {
        height: 9px;
        border-radius: 5px;
        background: rgba(63, 156, 255, 0.14);
        overflow: hidden;
        position: relative;
    }

    .level-fill {
        height: 100%;
        border-radius: 5px;
        position: relative;

        &::after {
            content: '';
            position: absolute;
            right: 0;
            top: -2px;
            bottom: -2px;
            width: 3px;
            background: #bfeaff;
            border-radius: 2px;
        }
    }

    .lv2 {
        background: linear-gradient(90deg, #b8860b, #ffd24a);
        box-shadow: 0 0 8px rgba(255, 210, 74, 0.7);
    }

    .lv3 {
        background: linear-gradient(90deg, #1b62e0, #4fc3ff);
        box-shadow: 0 0 8px rgba(79, 195, 255, 0.7);
    }

    .level-foot {
        margin-top: auto;
        padding-top: 12px;
        border-top: 1px dashed rgba(63, 156, 255, 0.22);
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #7ea6d9;

        b {
            color: #6fc4ff;
            font-family: Consolas, monospace;
            font-weight: 500;
        }
    }

    /* 工具栏 */
    .tm-toolbar {
        display: flex;
        gap: 10px;
        align-items: center;
        margin-bottom: 14px;
        flex-wrap: wrap;
    }

    .search-box {
        display: flex;
        align-items: center;
        gap: 8px;
        background: rgba(13, 40, 95, 0.5);
        border: 1px solid rgba(63, 156, 255, 0.4);
        border-radius: 5px;
        padding: 0 12px;
        height: 34px;
        width: 210px;

        input {
            background: transparent;
            border: none;
            outline: none;
            color: #cfe6ff;
            font-size: 13px;
            width: 100%;
        }

        input::placeholder { color: #4f77ab; }
    }

    select {
        height: 34px;
        padding: 0 10px;
        border-radius: 5px;
        background: rgba(13, 40, 95, 0.5);
        border: 1px solid rgba(63, 156, 255, 0.4);
        color: #a9c6e8;
        font-size: 13px;
        outline: none;
        cursor: pointer;

        option { background: #0a1f45; }
    }

    .btn {
        height: 34px;
        padding: 0 16px;
        border-radius: 5px;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid rgba(63, 156, 255, 0.45);
        background: rgba(13, 40, 95, 0.5);
        color: #a9c6e8;
        transition: all 0.2s;

        &:hover { border-color: #4fc3ff; color: #4fc3ff; }
    }

    .btn-primary {
        background: linear-gradient(180deg, #2a7de8, #1b62e0);
        border: 1px solid #4fc3ff;
        color: #fff;
        box-shadow: 0 0 12px rgba(42, 125, 232, 0.6);

        &:hover { filter: brightness(1.15); color: #fff; }
    }

    .btn-add {
        margin-left: auto;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(180deg, #22b98a, #0f8f6a);
        border: 1px solid #35e0b0;
        color: #eafff7;
        box-shadow: 0 0 12px rgba(53, 224, 176, 0.55);

        &:hover { filter: brightness(1.12); color: #fff; }
    }

    /* 表格 */
    table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
    }

    thead th {
        background: linear-gradient(180deg, rgba(30, 85, 190, 0.5), rgba(12, 38, 90, 0.5));
        color: #bfe0ff;
        font-size: 12px;
        font-weight: 500;
        padding: 12px 14px;
        text-align: left;
        letter-spacing: 1px;
        border-bottom: 1px solid rgba(79, 195, 255, 0.6);
        box-shadow: 0 2px 10px rgba(27, 98, 224, 0.25);
        white-space: nowrap;
    }

    tbody td {
        padding: 12px 14px;
        font-size: 13px;
        color: #c4dcf5;
        border-bottom: 1px solid rgba(63, 156, 255, 0.12);
        overflow: hidden;
        text-overflow: ellipsis;
    }

    tbody td.desc {
        white-space: normal;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 12px;
        color: #93b6de;
        line-height: 1.5;
    }

    tbody tr:nth-child(even) { background: rgba(20, 60, 140, 0.12); }

    tbody tr { transition: background 0.15s; }

    tbody tr:hover { background: rgba(63, 156, 255, 0.1); }

    tbody tr:hover td:first-child { box-shadow: inset 3px 0 0 #4fc3ff; }

    .t-name {
        color: #eaf6ff;
        cursor: pointer;
        white-space: nowrap;
    }

    .t-name:hover {
        color: #4fc3ff;
        text-shadow: 0 0 8px rgba(79, 195, 255, 0.6);
    }

    .tag {
        display: inline-block;
        font-size: 12px;
        padding: 2px 10px;
        border-radius: 3px;
        white-space: nowrap;
    }

    .tag-l2 {
        color: #ffd24a;
        border: 1px solid rgba(255, 210, 74, 0.45);
        background: rgba(255, 210, 74, 0.1);
    }

    .tag-l3 {
        color: #6fc4ff;
        border: 1px solid rgba(79, 195, 255, 0.45);
        background: rgba(27, 98, 224, 0.2);
    }

    .agent {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        font-family: Consolas, monospace;
        font-size: 11px;
        color: #35e0b0;
        white-space: nowrap;

        i {
            flex: none;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: currentColor;
            box-shadow: 0 0 8px currentColor;
        }
    }

    .score {
        font-family: Consolas, monospace;
        font-size: 15px;
        color: #ffd24a;
        text-shadow: 0 0 8px rgba(255, 210, 74, 0.6);
    }

    .op {
        white-space: nowrap;
        font-size: 0;

        a,
        span {
            cursor: pointer;
            font-size: 12px;
            margin-right: 12px;
            color: #6fc4ff;
            text-decoration: none;
        }

        a:hover,
        span:hover {
            color: #4fc3ff;
            text-shadow: 0 0 8px rgba(79, 195, 255, 0.6);
        }

        .del {
            color: #ff6b6b;
            margin-right: 0;
        }

        .del:hover {
            color: #ff8a8a;
            text-shadow: 0 0 8px rgba(255, 107, 107, 0.6);
        }
    }

    .tm-empty {
        padding: 28px 0;
        text-align: center;
        color: #5f8fd0;
        font-size: 12px;
    }

    .table-foot {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 13px 0 0;
        font-size: 12px;
        color: #7ea6d9;
    }

    ::v-deep .el-pagination {
        padding: 0;

        button,
        .el-pager li {
            background: rgba(13, 40, 95, 0.5) !important;
            color: #a9c6e8 !important;
            border: 1px solid rgba(63, 156, 255, 0.4);
            border-radius: 4px;
            min-width: 28px;
            height: 28px;
            line-height: 26px;
            font-size: 12px;
            margin: 0 3px;
        }

        button:disabled { opacity: 0.4; }

        .el-pager li.active {
            background: linear-gradient(180deg, #2a7de8, #1b62e0) !important;
            border-color: #4fc3ff;
            color: #fff !important;
            box-shadow: 0 0 10px rgba(79, 195, 255, 0.6);
        }

        .el-pager li:hover:not(.active) {
            border-color: #4fc3ff;
            color: #4fc3ff !important;
        }
    }

    @media (max-width: 1500px) {
        .tm-kpis { grid-template-columns: repeat(2, minmax(0, 1fr)); }

        .tm-grid { grid-template-columns: 1fr 1fr; }

        .tm-grid2 { grid-template-columns: 1fr; }

        .tm-rname { width: 140px; }
    }
}

    /* ===== 本页新增：说明行 / 排行榜 / 规模分布 ===== */
    .tm-grid2 {
        display: grid;
        grid-template-columns: 6fr 4fr;
        gap: 14px;
        margin-bottom: 16px;
    }

    .tm-chart-sm {
        height: 118px;
    }

    .tm-rank {
        display: flex;
        flex-direction: column;
        gap: 9px;
    }

    .tm-rank-row {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 12px;
    }

    .tm-no {
        flex: none;
        width: 20px;
        height: 20px;
        border-radius: 4px;
        font-size: 11px;
        font-family: Consolas, monospace;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(63, 156, 255, 0.14);
        color: #7ea6d9;
        border: 1px solid rgba(63, 156, 255, 0.3);

        &.n1 {
            background: linear-gradient(180deg, #e0a300, #b8860b);
            color: #fff7d6;
            border-color: #ffd24a;
            box-shadow: 0 0 10px rgba(255, 210, 74, 0.55);
        }

        &.n2 {
            background: linear-gradient(180deg, #8fa6c4, #5c7392);
            color: #f0f6ff;
            border-color: #a9c6e8;
        }

        &.n3 {
            background: linear-gradient(180deg, #b9762f, #8a5220);
            color: #ffeede;
            border-color: #d99354;
        }
    }

    .tm-rname {
        flex: none;
        width: 172px;
        color: #dceeff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .tm-track {
        flex: 1;
        height: 8px;
        border-radius: 4px;
        background: rgba(63, 156, 255, 0.13);
        overflow: hidden;
    }

    .tm-fill {
        height: 100%;
        border-radius: 4px;
        background: linear-gradient(90deg, #1b62e0, #4fc3ff);
        box-shadow: 0 0 8px rgba(79, 195, 255, 0.65);

        &.gold {
            background: linear-gradient(90deg, #b8860b, #ffd24a);
            box-shadow: 0 0 8px rgba(255, 210, 74, 0.7);
        }

        &.purple {
            background: linear-gradient(90deg, #6b46c1, #a78bfa);
            box-shadow: 0 0 8px rgba(167, 139, 250, 0.7);
        }
    }

    .tm-rval {
        flex: none;
        width: 58px;
        text-align: right;
        font-family: Consolas, monospace;
        font-size: 13px;
        color: #6fc4ff;
        text-shadow: 0 0 8px rgba(79, 195, 255, 0.55);

        b { font-weight: 500; font-size: 14px; }
    }

    .tm-legend {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 6px;

        .item {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 12px;
            color: #a9c6e8;
        }

        .dot {
            flex: none;
            width: 8px;
            height: 8px;
            border-radius: 2px;
            box-shadow: 0 0 8px currentColor;
        }

        .num {
            margin-left: auto;
            font-family: Consolas, monospace;
            font-size: 13px;
            color: #dceeff;
        }

        .pct {
            width: 46px;
            text-align: right;
            font-family: Consolas, monospace;
            font-size: 12px;
            color: #6fc4ff;
        }
    }

    .tm-dist {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 6px;

        .item {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 12px;
            color: #a9c6e8;
        }

        .lb { flex: none; width: 60px; }

        .track {
            flex: 1;
            height: 8px;
            border-radius: 4px;
            background: rgba(63, 156, 255, 0.13);
            overflow: hidden;
        }

        .fill {
            height: 100%;
            border-radius: 4px;
            background: linear-gradient(90deg, #0f8f6a, #35e0b0);
            box-shadow: 0 0 8px rgba(53, 224, 176, 0.6);
        }

        .num {
            flex: none;
            width: 40px;
            text-align: right;
            font-family: Consolas, monospace;
            font-size: 13px;
            color: #35e0b0;
        }
    }

    .tm-id {
        font-family: Consolas, monospace;
        color: #7ea6d9;
    }

    .tm-dept {
        color: #93b6de;
        font-size: 12px;
    }

    .tm-num {
        font-family: Consolas, monospace;
        font-size: 14px;
        color: #dceeff;

        &.hot {
            color: #ffd24a;
            text-shadow: 0 0 8px rgba(255, 210, 74, 0.6);
        }

        &.none { color: #4f77ab; }
    }

    .tag-l4 {
        color: #a78bfa;
        border: 1px solid rgba(167, 139, 250, 0.45);
        background: rgba(167, 139, 250, 0.1);
    }
</style>

<!-- 非scoped样式：弹层与tooltip需全局生效 -->
<style lang="less">
.el-tooltip__popper {
    max-width: 300px !important;
    width: auto !important;
    white-space: normal !important;
    word-break: break-all !important;
    line-height: 1.4 !important;
}

.tm-pop.el-popover {
    background: #0a1f45;
    border: 1px solid rgba(63, 156, 255, 0.45);
    color: #cfe6ff;
}

.tm-pop.el-popover .tm-options { padding: 2px 0; }

.tm-pop.el-popover .tm-option {
    padding: 8px 14px;
    font-size: 13px;
    color: #a9c6e8;
    cursor: pointer;
    transition: all .2s;
}

.tm-pop.el-popover .tm-option:hover {
    background: rgba(63, 156, 255, 0.18);
    color: #4fc3ff;
}
</style>
